import { store } from "@store";
import { getEntities, isVersionInEditor } from "@store/story/selectors";
import { getTableVersionBinding } from "./table-version-binding";

/**
 * Whether this table is locked on the version canvas: a whole-table variable
 * (data, or a legacy list) fills it, so it is edited only through its data
 * sheet until "Make static". Nothing may land in its cells then — not a
 * sidebar drag, an in-cell move, a paste or a click-to-insert — or the edit
 * would sit under data the version's payload replaces. Any other table is the
 * version's own content and is edited in place.
 */
export const isTableLockedInVersion = (
  tableId: string | null | undefined,
  state = store.getState(),
): boolean => {
  if (!tableId || !isVersionInEditor(state)) return false;
  const table = getEntities(state)[tableId] as
    | { settings?: Parameters<typeof getTableVersionBinding>[0] }
    | undefined;
  return getTableVersionBinding(table?.settings, true, undefined) !== null;
};
